import { render, staticRenderFns } from "./about-order.vue?vue&type=template&id=f3bf0cc0&scoped=true&"
import script from "./about-order.vue?vue&type=script&lang=js&"
export * from "./about-order.vue?vue&type=script&lang=js&"
import style0 from "./about-order.vue?vue&type=style&index=0&id=f3bf0cc0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f3bf0cc0",
  null
  
)

export default component.exports